<template>
  <v-card :flat="!bSafe">
    <v-stepper v-model="e1" flat>
      <v-stepper-items>
        <v-stepper-content step="1" class="education_make_scroll pa-0">
          <v-card class="pl-4 pr-4" flat id="1">
            <v-card-title class="education_title">
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
              <v-divider vertical class="ml-5 mr-5"></v-divider>
              <div class="red--text text--darken-2 education_title_notitext">{{$store.state.CustomInfo.SiteNm}} 보안 교육</div>
            </v-card-title>
            <!-- <v-card-title>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height:45px"/>
              <v-divider vertical class="ml-5 mr-5"></v-divider>
              <div class="text-h4 red--text text--darken-2 education_title_text">{{$store.state.CustomInfo.SiteNm}} 보안 교육</div>
            </v-card-title> -->
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="education_content lineHeight2 er">
              모두에게 가치 있는 최고의 파트너, <strong class="red--text text--lighten-1">{{$store.state.CustomInfo.SiteNm}}</strong> 방문을 환영합니다. <br>
            </v-card-text>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="2" class="education_make_scroll pa-0">
          <v-card class="pl-4 pr-4" flat id="2">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">건물 출입 주의사항</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="education_content lineHeight2">
              <div class="d-flex">
                <v-icon class="align-self-start mt-1 mr-1">mdi-check</v-icon>
                <div>
                  방문 예약 시, 건물로 출입이 필요하신 경우에는 {{$store.state.CustomInfo.SiteNm}} 담당자에게 요청 하고<strong class="red--text text--lighten-1"> 해당 담당자와 동행 하에 출입이 가능합니다.</strong>
                </div>
                <!-- <div>
                  방문 예약 시, 건물로 출입이 필요하신 경우에는 {{$store.state.CustomInfo.SiteNm}} 담당자에게 요청해야 하고<strong class="red--text text--lighten-1"> {{$store.state.CustomInfo.SiteNm}} 구성원과 동행 하에 출입이 가능합니다.</strong>
                </div> -->
              </div>
              <div class="d-flex">
                <v-icon class="align-self-start mt-1 mr-1">mdi-check</v-icon>
                <div>
                  사내에서 방문 목적을 벗어난 지역에 임의로 들어가셔서는 안 됩니다.
                </div>
              </div>
              <div class="d-flex">
                <v-icon class="align-self-start mt-1 mr-1">mdi-check</v-icon>
                <div>
                  <strong class="red--text text--lighten-1"> 방문 업무가 종료되면 즉시 출문해야 합니다.</strong>
                </div>
              </div>
            </v-card-text>

            <div class="d-flex justify-center mt-5 mb-6">
              <img src="../assets/sec/Sec_Study_man.jpg" style="max-width:200px;width:40%;"/>
              <img src="../assets/sec/Sec_Study_man2.jpg" style="max-width:200px;width:40%;"/>
            </div>
            
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="3" class="education_make_scroll pa-0">
          <v-card class="pl-4 pr-4 mb-12" flat id="3">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">사내 사진 촬영 금지</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="education_content lineHeight2">
              <div class="d-flex">
                <v-icon class="align-self-start mt-1 mr-1">mdi-check</v-icon>
                <div>
                  {{$store.state.CustomInfo.SiteNm}} Site 내 사진 촬영이 금지되어 있으므로, 출입 시에 <strong class="red--text text--lighten-1">휴대전화 카메라 렌즈 및 영상통화 렌즈</strong>는 스티커로 봉인하셔야 합니다. <br>
                </div>
              </div>
              <div class="d-flex">
                <strong class="blue--text text--lighten-1 font-weight-black ml-5">※</strong>
                <strong class="blue--text text--lighten-1 font-weight-black ml-2">휴대전화케이스 위 부착, 필름 위 부착, 이중 부착 등의 간접 봉인이 적발될 시 보안 위규로 당사 출입 관련 불이익이 발생할 수 있습니다.</strong>
              </div>
            </v-card-text>

            <div class="mt-0 hidden-xs-only">
              <div class="sec_box">
                <div class="flex-wrap d-flex justify-center mt-0 mb-0">
                  <v-card min-width="100" class="ma-2 text-center" color="blue" dark> 
                    <div class="mt-10"><v-icon>mdi-check-circle</v-icon></div>
                    <div class="mt-2">정상 부착</div>
                  </v-card>
                  <v-card width="220" class="ma-2">
                    <v-img
                      src="../assets/sec/sec_phone1.png"
                      class="white--text align-end"
                      gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
                      height="120px"
                    >
                    <v-card-title class="text-body Inimg_Font">보호필름과 함께 부착</v-card-title>
                    </v-img>
                  </v-card>
                  <v-card width="220" class="ma-2">
                    <v-img
                      src="../assets/sec/sec_phone2.png"
                      class="white--text align-end"
                      gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
                      height="120px"
                    >
                    <v-card-title class="Inimg_Font">케이스 내부에 부착</v-card-title>
                    </v-img>
                  </v-card>
                  <v-card width="220" class="ma-2">
                    <v-img
                      src="../assets/sec/sec_phone3.png"
                      class="white--text align-end"
                      gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
                      height="120px"
                    >
                    <v-card-title class="Inimg_Font">렌즈에 밀착 부착</v-card-title>
                    </v-img>
                  </v-card>
                </div>
              </div>
              <div class="sec_box mt-2">
                <div class="flex-wrap d-flex justify-center mt-0 mb-0">
                  <v-card min-width="100" class="ma-2 text-center" color="red" dark> 
                    <div class="mt-10"><v-icon>mdi-close-circle</v-icon></div>
                    <div class="mt-2">위규 사항</div>
                  </v-card>
                  <v-card width="220" class="ma-2">
                    <v-img
                      src="../assets/sec/sec_phone4.png"
                      class="white--text align-end"
                      gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
                      height="120px"
                    >
                    <v-card-title class="text-body Inimg_Font">보호필름에만 부착 시</v-card-title>
                    </v-img>
                  </v-card>
                  <v-card width="220" class="ma-2">
                    <v-img
                      src="../assets/sec/sec_phone5.png"
                      class="white--text align-end"
                      gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
                      height="120px"
                    >
                    <v-card-title class="Inimg_Font">보안 스티커 훼손 시</v-card-title>
                    </v-img>
                  </v-card>
                  <v-card width="220" class="ma-2">
                    <v-img
                      src="../assets/sec/sec_phone6.png"
                      class="white--text align-end"
                      gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
                      height="120px"
                    >
                    <v-card-title class="Inimg_Font">밀착 부착 안된 경우</v-card-title>
                    </v-img>
                  </v-card>
                </div>
              </div>
            </div>
            
            <div class="mt-0 hidden-sm-and-up">
              <div class="sec_box">
                <div class="d-flex flex-column align-center mt-0 mb-0">
                  <v-card width="220" class="ma-2 text-center" color="blue" dark> 
                    <div class="mt-2"><v-icon>mdi-check-circle</v-icon></div>
                    <div class="mt-2 pb-2">정상 부착</div>
                  </v-card>
                  <v-card width="220" class="ma-2">
                    <v-img
                      src="../assets/sec/sec_phone1.png"
                      class="white--text align-end"
                      gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
                      height="120px"
                    >
                    <v-card-title class="text-body Inimg_Font">보호필름과 함께 부착</v-card-title>
                    </v-img>
                  </v-card>
                  <v-card width="220" class="ma-2">
                    <v-img
                      src="../assets/sec/sec_phone2.png"
                      class="white--text align-end"
                      gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
                      height="120px"
                    >
                    <v-card-title class="Inimg_Font">케이스 내부에 부착</v-card-title>
                    </v-img>
                  </v-card>
                  <v-card width="220" class="ma-2">
                    <v-img
                      src="../assets/sec/sec_phone3.png"
                      class="white--text align-end"
                      gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
                      height="120px"
                    >
                    <v-card-title class="Inimg_Font">렌즈에 밀착 부착</v-card-title>
                    </v-img>
                  </v-card>
                </div>
              </div>
              <div class="sec_box mt-2">
                <div class="d-flex flex-column align-center mt-0 mb-0">
                  <v-card width="220" class="ma-2 text-center" color="red" dark> 
                    <div class="mt-2"><v-icon>mdi-close-circle</v-icon></div>
                    <div class="mt-2 pb-2">위규 사항</div>
                  </v-card>
                  <v-card width="220" class="ma-2">
                    <v-img
                      src="../assets/sec/sec_phone4.png"
                      class="white--text align-end"
                      gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
                      height="120px"
                    >
                    <v-card-title class="text-body Inimg_Font">보호필름에만 부착 시</v-card-title>
                    </v-img>
                  </v-card>
                  <v-card width="220" class="ma-2">
                    <v-img
                      src="../assets/sec/sec_phone5.png"
                      class="white--text align-end"
                      gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
                      height="120px"
                    >
                    <v-card-title class="Inimg_Font">보안 스티커 훼손 시</v-card-title>
                    </v-img>
                  </v-card>
                  <v-card width="220" class="ma-2">
                    <v-img
                      src="../assets/sec/sec_phone6.png"
                      class="white--text align-end"
                      gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
                      height="120px"
                    >
                    <v-card-title class="Inimg_Font">밀착 부착 안된 경우</v-card-title>
                    </v-img>
                  </v-card>
                </div>
              </div>
            </div>
          </v-card>
        </v-stepper-content>


        <v-stepper-content step="4" class="education_make_scroll pa-0">
          <v-card class="pl-4 pr-4 mb-12" flat id="4">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">전산 저장장치 무단 반입 금지</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="education_content lineHeight2">
              <div class="d-flex">
                <v-icon class="align-self-start mt-1 mr-1">mdi-check</v-icon>
                <div>
                  전산 저장장치의 사용이 필요하실 경우에는 방문 예약 시 <strong class="red--text text--lighten-1">"업체 물품 반입 신청"</strong>을 신청하셔야 합니다.
                </div>
              </div>
              <div class="d-flex">
                <v-icon class="align-self-start mt-1 mr-1">mdi-check</v-icon>
                <div>
                  사용하지 않을 전산 저장장치를 소지하신 경우에는 <strong class="red--text text--lighten-1">스피드게이트 인근 물품 보관함</strong>에 보관하신 후에 출입하시면 됩니다.
                </div>
              </div>
              <div class="d-flex">
                <strong class="blue--text text--lighten-1 font-weight-black ml-5">※</strong>
                <strong class="blue--text text--lighten-1 font-weight-black ml-2">예약 물품, 허가받은 태블릿 PC와 노트북만 반입이 가능합니다.</strong>
              </div>
            </v-card-text>


            <div class="ma-5">
              <div class="flex-wrap d-flex justify-center mt-0 mb-0">
                <v-card width="250" class="ma-2">
                  <v-img
                    src="../assets/sec/sec_in1.jpg"
                    class="white--text align-end"
                    gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
                    height="205px"
                  >
                  <v-card-title class="text-body Inimg_Font">외장하드</v-card-title>
                  </v-img>
                </v-card>
                <v-card width="250" class="ma-2">
                  <v-img
                    src="../assets/sec/sec_in2.jpg"
                    class="white--text align-end"
                    gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
                    height="205px"
                  >
                  <v-card-title class="Inimg_Font">메모리 스틱</v-card-title>
                  </v-img>
                </v-card>


                <v-card width="250" class="ma-2">
                  <v-img
                    src="../assets/sec/sec_in3.jpg"
                    class="white--text align-end"
                    gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
                    height="205px"
                  >
                  <v-card-title class="Inimg_Font">노트북</v-card-title>
                  </v-img>
                </v-card>

                <v-card width="250" class="ma-2">
                  <v-img
                    src="../assets/sec/sec_in4.jpg"
                    class="white--text align-end"
                    gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
                    height="205px"
                  >
                  <v-card-title class="Inimg_Font">CD, 디스켓</v-card-title>
                  </v-img>
                </v-card>
              </div>
            </div>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="5" class="education_make_scroll pa-0">
          <v-card class="pl-4 pr-4 mb-12" flat id="5">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">무선 통신 기기 반입 금지</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="education_content lineHeight2 red--text">
              <div class="d-flex">
                <v-icon class="red--text text--lighten-1 align-self-start">mdi-check</v-icon>
                <strong class="red--text text--lighten-1"> 무선 인터넷이 가능한 무선통신기기는 반입하실 수 없습니다.</strong>
              </div>
            </v-card-text>


            <div class="ma-5">
              <div class="flex-wrap d-flex justify-center mt-0 mb-0">
                <v-card width="250" class="ma-2">
                  <v-img
                    src="../assets/sec/sec_in_device1.png"
                    class="white--text align-end"
                    gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
                    height="205px"
                  >
                  <v-card-title class="Inimg_Font">와이브로 모뎀(EGG, 포켓파이)</v-card-title>
                  </v-img>
                </v-card>
                <v-card width="250" class="ma-2">
                  <v-img
                    src="../assets/sec/sec_in_device2.png"
                    class="white--text align-end"
                    gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
                    height="205px"
                  >
                  <v-card-title class="Inimg_Font">유/무선공유기, NAS</v-card-title>
                  </v-img>
                </v-card>


                <v-card width="250" class="ma-2">
                  <v-img
                    src="../assets/sec/sec_in_device3.png"
                    class="white--text align-end"
                    gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
                    height="205px"
                  >
                  <v-card-title class="Inimg_Font">USB/PCMCIA 무선랜카드</v-card-title>
                  </v-img>
                </v-card>

                <v-card width="250" class="ma-2">
                  <v-img
                    src="../assets/sec/sec_in_device4.png"
                    class="white--text align-end"
                    gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
                    height="205px"
                  >
                  <v-card-title class="Inimg_Font">HSDPA 모뎀</v-card-title>
                  </v-img>
                </v-card>
                <v-card width="250" class="ma-2">
                  <v-img
                  src="../assets/sec/sec_in_device5.png"
                    class="white--text align-end"
                    gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
                    height="205px"
                  >
                  <v-card-title class="Inimg_Font">EV-DO 방식 휴대용 USB 모뎀</v-card-title>
                  </v-img>
                </v-card>
              </div>
            </div>

          </v-card>
        </v-stepper-content>


        <v-stepper-content step="6" class="education_make_scroll pa-0">
          <v-card class="pl-4 pr-4" flat id="6">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">문서 및 물품 반·출입 금지</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="education_content lineHeight2">
              <div class="d-flex">
                <v-icon class="align-self-start mt-1 mr-1">mdi-check</v-icon>
                <div>
                  문서 및 물품을 임의로 반·출입해서는 안 됩니다.
                </div>
              </div>
              <div class="d-flex">
                <v-icon class="align-self-start mt-1 mr-1">mdi-check</v-icon>
                <div>
                  반·출입이 필요할 경우에는 <strong class="red--text text--lighten-1">담당자</strong>에게 의뢰하셔서 내부 보안 절차를 준수해주시기를 바랍니다.
                </div>
                <!-- <div>
                  반·출입이 필요할 경우에는 <strong class="red--text text--lighten-1">{{$store.state.CustomInfo.SiteNm}} 담당자</strong>에게 의뢰하셔서 내부 보안 절차를 준수해주시기를 바랍니다.
                </div> -->
              </div>
              <div class="d-flex">
                <v-icon class="align-self-start mt-1 mr-1 red--text text--lighten-1">mdi-check</v-icon>
                <strong class="red--text text--lighten-1"> 외부 반입 문서는 통합보안실에서 확인 도장을 받은 후 반입합니다.</strong>
              </div>
            </v-card-text>
            <div class="d-flex justify-center mt-0 mb-0">
              <img src="../assets/sec/sec_doc.jpg" style="max-height:300px;max-width:300px;width:80%;"/>
            </div>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="7" class="education_make_scroll pa-0">
          <v-card class="pl-4 pr-4 mb-12" flat id="7">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">차량 출입 주의 사항</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="education_content lineHeight2">
              <div class="d-flex">
                <v-icon class="align-self-start mt-1 mr-1">mdi-check</v-icon>
                 <div>
                  개인 차량으로 방문할 경우에는 <strong class="red--text text--lighten-1">방문객 전용 주차장</strong>을 이용하시기를 바랍니다.
                 </div>
              </div>
              <div class="d-flex">
                <v-icon class="align-self-start mt-1 mr-1">mdi-check</v-icon>
                 <div>
                   사내에 차량 출입이 필요한 경우에는 담당자에게 의뢰해야 합니다.
                 </div>
                 <!-- <div>
                   사내에 차량 출입이 필요한 경우에는 <strong class="red--text text--lighten-1">{{$store.state.CustomInfo.SiteNm}}</strong> 담당자에게 의뢰해야 합니다.
                 </div> -->
              </div>
              <div class="d-flex ml-8 mb-1 red--text text--lighten-1">
                -<div>&nbsp;사내 차량 규정 속도를 준수합니다. <br><strong>승용차, 오토바이, 자전거 : 20km/h<br>화물차량(1ton), 중장비, 지게차 : 10km/h</strong></div>
              </div>
              <div class="d-flex ml-8 mb-1 red--text text--lighten-1">
                -<div>&nbsp;사내 차량 단속 기준(주·정차 위반, 과속, 중식 시간 차량 운행 금지)을 준수합니다.</div>
              </div>
              <div class="d-flex ml-8 mb-1 red--text text--lighten-1">
                -<div>&nbsp;출문 시, 시행하는 트렁크 <strong>보안 검색</strong> 협조해주시기를 바랍니다.</div>
              </div>
            </v-card-text>
            <div class="flex-wrap d-flex justify-center mt-5 mb-6">
              <img class="mr-2" src="../assets/sec/sec_car1.jpg" style="height:300px"/>
              <img class="mt-10" src="../assets/sec/sec_car2.jpg" style="height:200px; border-radius: 10px;"/>
              <img class="ml-2" src="../assets/sec/sec_car3.jpg" style="height:250px"/>
            </div>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="8" class="education_make_scroll pa-0">
          <v-card class="pl-4 pr-4" flat id="8">
            <v-card-title class="education_title">
              <div class="red--text text--darken-2 education_title_text">보안 규정 위반 후속 조치</div>
              <v-spacer></v-spacer>
              <img :src="'logo_' + $store.state.CustomInfo.SiteId + '.svg'" style="height: 50px;">
            </v-card-title>
            <v-divider class="mb-2"></v-divider>
            <v-card-text class="education_content lineHeight2">
              <div class="d-flex">
                <v-icon class="align-self-start mt-1 mr-1">mdi-check</v-icon>
                <div>
                  {{$store.state.CustomInfo.SiteNm}} 출입 중 산업 보안 준수사항을 위반할 경우 보안 위반으로 조치됩니다.
                </div>
              </div>
              <div class="d-flex">
                <v-icon class="align-self-start mt-1 mr-1">mdi-check</v-icon>
                <div>
                  보안 위반은 사유서 징구부터 <strong class="red--text text--lighten-1">영구출입 정지</strong>까지 조치될 수 있습니다.
                </div>
              </div>
              <div class="d-flex">
                <v-icon class="align-self-start mt-1 mr-1">mdi-check</v-icon>
                <div>
                  사유서 와 시정 공문 작성은 보안 위반 조치일로부터 <strong class="red--text text--lighten-1">14일 이내</strong> 방문예약 사이트에서 작성해야 합니다.
                </div>
              </div>
              <div class="d-flex">
                <v-icon class="align-self-start mt-1 mr-1">mdi-check</v-icon>
                <div>
                  보안 위반은 단순 절차 위반 시에도 <strong class="red--text text--lighten-1">연간 위반 건수</strong>가 누적되어 추가 조치될 수 있습니다.
                </div>
              </div>
              
            </v-card-text>
          </v-card>
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>

    <div v-show="e1 == 1" class="text-caption hidden-md-and-up" style="position:relative; bottom:0px;margin-left:20px;">
      본 교육은 6개월마다 재교육을 받아야 합니다.
    </div>
    <v-card-actions class="pa-4">
      <div v-show="e1 == 1" class="text-caption hidden-sm-and-down pl-4">
        본 교육은 6개월마다 재교육을 받아야 합니다.
      </div>
      <v-spacer></v-spacer>
      <v-btn v-show="e1 == 1" @click="$emit('ResetEdu')" text width="100"><v-icon>mdi-close</v-icon>취소</v-btn>
      <v-btn v-show="e1 != 1" text width="100" @click="PreviewPage()"><v-icon>mdi-chevron-left</v-icon>뒤로</v-btn>
      <v-btn v-show="e1 != 8" @click="NextPage()" width="100" dark><v-icon>mdi-chevron-right</v-icon>계속</v-btn>
      <v-btn v-show="e1 == 8" width="100" @click="$emit('CloseEdu')" dark><v-icon>mdi-chevron-right</v-icon>완료</v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>

export default {
  components: {
  },
  data: () => ({  
    e1: 1,
  }),
  props: ["bSafe"],

  
  mounted () {
  },

  methods: {
    NextPage(){
      this.e1 += 1
      setTimeout(() => {
        var element =  document.getElementById(this.e1);
        element.scrollIntoView({behavior : "smooth"})
      }, 10);
    },

    PreviewPage(){
      this.e1 -= 1
      setTimeout(() => {
        var element =  document.getElementById(this.e1);
        element.scrollIntoView({behavior : "smooth"})
      }, 10);
    },
  }
};
</script>

<style scoped lang="scss">
  @import "@/publishing/visit.scss";
  .Inimg_Font{
    @media screen and (min-width: 626px) {
      font-size: 17px;
    }

    @media screen and (max-width: 625px){
      font-size: 15px;
    }
  }
  .lineHeight2{
    line-height: 180%
  }
  .sec_box{
    margin: auto;        
    text-align: center;
    box-shadow: 0px 0px 1px 1px #f3f3f3; 
  }
</style>
